import React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import { BoxWrapper } from 'components/Base';
import TableComponents from 'components/Table';
import { Field, change } from 'redux-form';
import Fields from 'components/Fields';
import { FieldCurrency, FieldPercent } from 'components/Base';
import Store from 'store/store';
import { ChargeType } from 'store/modules/ExistingPolicies/types';
import {
  formatCurrency,
  formatPercent,
  unFormatCurrency,
  unFormatPercent
} from 'utils';

const { connect } = Store;

const useStyles = makeStyles((theme: Theme) => ({
  rows: {
    padding: '0.2rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(0)
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2)
  },
  table: {
    width: 'calc(100% + 1px)' // fix chrome bug,
  },
  tableBody: {
    '& tr:nth-child(odd)': {
      backgroundColor: '#f7f7f7'
    }
  },
  wrapper: {
    margin: '6px 0',
    marginLeft: '10px'
  },
  loaderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  totalRow: {
    height: '60px',
    marginTop: '5px',
    padding: '1rem 0',
    backgroundColor: '#fff !important',
    borderTop: '1px solid #eaeaea',
    '& td ': {
      fontWeight: '600',
      color: '#0080bd'
    }
  }
}));

interface Props {
  fields?: any;
  changeField: any;
  formName: any;
  aggregateMPmanagmentCharge: ChargeType;
  getMpValue: Function;
}

const ModelPortfolioCharges = ({
  fields,
  changeField,
  formName,
  aggregateMPmanagmentCharge,
  getMpValue
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <BoxWrapper title="Portfolio management charges (inc. VAT)">
        <Table className={classes.table}>
          <TableComponents.TableHead
            cells={['Model Portfolio', '% p.a.', '£ p.a.']}
          />
          <TableComponents.TableBody>
            {fields.map((modelPortfolioCharge: any, index: number) => {
              const chargeId = fields.get(index)?.id;

              return (
                <TableComponents.TableRow key={index}>
                  <TableComponents.TableCell>
                    <Field
                      name={`${modelPortfolioCharge}.name`}
                      fullWidth
                      component={Fields.String}
                      disabled
                      readOnly
                    />
                  </TableComponents.TableCell>
                  <TableComponents.TableCell style={{ width: '100px' }}>
                    <FieldPercent
                      name={`${modelPortfolioCharge}.percentage_value`}
                      fullWidth
                      clearfieldinform={formName}
                      onChange={(event: any) => {
                        changeField(
                          formName,
                          `${modelPortfolioCharge}.cash_value`,
                          formatCurrency(
                            getMpValue(chargeId) *
                              Number(unFormatPercent(event.target.value) / 100)
                          )
                        );
                        changeField(
                          formName,
                          `${modelPortfolioCharge}.source_value`,
                          2
                        );
                        changeField(
                          formName,
                          `${modelPortfolioCharge}.manually_overriden`,
                          true
                        );
                      }}
                      validate={Fields.Validators.isChargePercentageValid}
                      component={Fields.Text}
                    />
                  </TableComponents.TableCell>
                  <TableComponents.TableCell style={{ width: '120px' }}>
                    <FieldCurrency
                      name={`${modelPortfolioCharge}.cash_value`}
                      fullWidth
                      clearfieldinform={formName}
                      onChange={(event: any) => {
                        changeField(
                          formName,
                          `${modelPortfolioCharge}.percentage_value`,
                          formatPercent(
                            (Number(unFormatCurrency(event.target.value)) /
                              getMpValue(chargeId)) *
                              100
                          )
                        );
                        changeField(
                          formName,
                          `${modelPortfolioCharge}.source_value`,
                          1
                        );
                        changeField(
                          formName,
                          `${modelPortfolioCharge}.manually_overriden`,
                          true
                        );
                      }}
                      component={Fields.Text}
                    />
                  </TableComponents.TableCell>
                </TableComponents.TableRow>
              );
            })}
          </TableComponents.TableBody>
          <tfoot>
            <TableComponents.TableRow className={classes.totalRow}>
              <TableComponents.TableCell>Total</TableComponents.TableCell>
              <TableComponents.TableCell>
                {aggregateMPmanagmentCharge.percentage_value}
              </TableComponents.TableCell>
              <TableComponents.TableCell>
                {aggregateMPmanagmentCharge.cash_value}
              </TableComponents.TableCell>
            </TableComponents.TableRow>
          </tfoot>
        </Table>
      </BoxWrapper>
    </div>
  );
};

export default connect(null, { changeField: change })(ModelPortfolioCharges);
